module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_213.75deg.b59f4071.png";